import axios from "axios";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";
import type { RenderResponse } from "../types/banner";

export async function fetchRenderConfig(signal?: AbortSignal): Promise<RenderResponse> {
    const config: any = {};
    if (signal) config.signal = signal;
    const resp = await axios.get<RenderResponse>(PKSOFT_URLS.CUSTOMER.RENDER, config);
    return resp.data;
}

export interface CategoryBrandItem {
    id?: string;
    name?: string;
    image?: string;
    pageUrl?: string;
    link?: string;
    [key: string]: any;
}

export interface CategoryBrandResponse {
    status?: number;
    messageCode?: number;
    message?: string;
    data?: CategoryBrandItem[];
}

export async function fetchCategoryBrands(categoryCode: string, signal?: AbortSignal): Promise<CategoryBrandResponse> {
    const config: any = {};
    if (signal) config.signal = signal;
    const url = `${PKSOFT_URLS.CUSTOMER.CATEGORY_BRAND}/${categoryCode}`;
    const resp = await axios.get<CategoryBrandResponse>(url, config);
    return resp.data;
}

export default { fetchRenderConfig, fetchCategoryBrands };